import { render, staticRenderFns } from "./EditConfig.vue?vue&type=template&id=89f8ed60&scoped=true&"
import script from "./EditConfig.vue?vue&type=script&lang=js&"
export * from "./EditConfig.vue?vue&type=script&lang=js&"
import style0 from "./EditConfig.vue?vue&type=style&index=0&id=89f8ed60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f8ed60",
  null
  
)

export default component.exports